// 로그인·회원가입·비밀번호 찾기·재설정 공통 틀 (2026-10-19 리뉴얼)
// 왼쪽: 제목 + 내 그림 → 쿠키커터 한 쌍 + 좋은 점 / 오른쪽: 각 화면의 입력칸
// 모바일(700px 이하)에서는 왼쪽 칸을 숨긴다.
import { useTranslation } from "react-i18next";
import "../pages/Auth/AuthSplit.css";

export default function AuthSplit({ hero1, hero2, lead, benefits = false, title, sub, after, children }) {
  const { t } = useTranslation();
  return (
    <div className="ca-auth">
      <div className="ca-split">
        <div className="ca-left">
          <div>
            <div className="ca-hero">{hero1}<br /><span>{hero2}</span></div>
            <p className="ca-lead">{lead}</p>
          </div>
          <div className="ca-pair">
            <figure>
              <div className="ca-pic ca-pic-draw"><img src="/home/cookistory-logo-lines.svg" alt="" /></div>
              <figcaption>{t("auth_split.my_drawing")}</figcaption>
            </figure>
            <span className="ca-arrow" aria-hidden>→</span>
            <figure>
              <div className="ca-pic"><img src="/auth/logo-cutter.png" alt="" /></div>
              <figcaption>{t("auth_split.cutter")}</figcaption>
            </figure>
          </div>
          {benefits ? (
            <ul className="ca-benefits">
              <li><i>✓</i>{t("auth_split.benefit_drive")}</li>
              <li><i>✓</i>{t("auth_split.benefit_gallery")}</li>
              <li><i>✓</i>{t("auth_split.benefit_like")}</li>
            </ul>
          ) : <div />}
        </div>
        <div className="ca-right">
          <h2 className="ca-title">{title}</h2>
          {sub && <p className="ca-sub">{sub}</p>}
          {children}
        </div>
      </div>
      {after}
    </div>
  );
}
